import { useContext, useEffect, useState } from 'react'
import { ImperialBookingContext } from '../context/ImperialBookingContext'
import useApiRequest from './useApiRequest'
import { cloneDeep } from 'lodash-es'

const sort = (col, key) => {
  return col.sort((a, b) => {
    if (typeof a[key] === "string") {
      return a[key].toLowerCase().localeCompare(b[key].toLowerCase())
    } else {
      return a[key] - b[key]
    }
  })
}

const useResidents = (fetchOnMount = false) => {
  const { apiGet, apiPost } = useApiRequest()
  const {
    residents,
    setResidents,
    residentsLoaded,
    setResidentsLoaded,
    //getCredentials,
  } = useContext(ImperialBookingContext)

  const [bookings, setBookings] = useState(undefined)
  const [bookingsLoaded, setBookingsLoaded] = useState(false)

  const fetchResidents = async () => {
    return apiGet('residents')
      .then((data) => {
        setResidents(sort(data, 'unit'))
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setResidentsLoaded(true)
      })
  }

  const updateResident = (residentId, data) => {
    const resident = residents.find((resident) => resident.id === residentId);
    console.log('resident', resident, data);
    Object.assign(resident, data);
    setResidents(cloneDeep(residents))
  }

  //const saveResidents = async () => {
  //  const { userId } = await getCredentials()

  //  const payload = {
  //    user_id: userId,
  //  }

  //  return apiPost(`residents`, payload)
  //    .then(() => {
  //      fetchResidents()
  //    })
  //}

  const sortResidents = (key) => {
    switch (key) {
      case 'unit':
      case 'last_name':
        setResidents(sort(cloneDeep(residents), key))
        break
    }
  }

  const getResident = (residentId) => {
    return residents.find((r) => (r.id === residentId))
  }

  const getResidentBookings = async (residentId) => {
    return apiGet(`residents/${residentId}/bookings`)
      .then((data) => {
        setBookings(data)
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setBookingsLoaded(true)
      })
  }

  useEffect(() => {
    if (!residents || fetchOnMount) {
      fetchResidents()
    }
  }, [])

  const disableResident = async (residentId) => {
    console.log('Disable Resident', residentId)
    return apiPost(`residents/${residentId}/disable`)
      .then((data) => {
        console.log('Disable resident', data)
        updateResident(residentId, data)
        return data;
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const getResidentNotes = async (residentId) => {
    return apiGet(`residents/${residentId}/notes`)
  }

  return {
    residents,
    fetchResidents,
    residentsLoaded,
    sortResidents,
    getResident,
    getResidentBookings,
    bookingsLoaded,
    bookings,
    disableResident,
    getResidentNotes
    //saveResidents,
  }
}


export default useResidents

